function decodeJWT() {
  const token = localStorage.getItem("token");

  if (!token) {
    console.error("No token provided.");
    return null;
  }

  const parts = token.split(".");
  if (parts.length !== 3) {
    console.error("Invalid JWT token format.");
    return null;
  }

  try {
    const payload = atob(parts[1]);
    const parsedPayload = JSON.parse(payload);

    const userData = parsedPayload?.user || parsedPayload?.newUser;

    if (!userData) {
      console.error("Invalid payload structure.");
      return null;
    }

    const { password, attributes, capabilities, createdAt, editedAt, ...user } = userData;

    return user;

  } catch (error) {
    console.error("Failed to decode JWT token:", error);
    return null;
  }
}

export default decodeJWT;
